<template>
    <main> 
        <link rel="stylesheet" href="https://wevisu.com/assets/style/style.css" scope />
        <TopHeader /> 
        <router-view style="min-height:75vh;margin-top: 0px;" :key="$route.fullPath"></router-view>
        <Footer />
        <vue-progress-bar></vue-progress-bar>
    </main>
</template>

<script>


import TopHeader from "../snippets/New/Header.vue"; 
import Footer from "../snippets/New/Footer.vue";
import { mapGetters } from "vuex";

export default {
    components: {
        TopHeader, 
        Footer
    },
    computed: {
        ...mapGetters({
            showroomId: "Common/MyItem"
        }),
        newHeader() {
            return this.$route.meta.newHeader || "No";
        }
    },
    data() {
        return {
            currentUrl: window.location.href,
            categoryList: []
        };
    }
};
</script>
